import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { BreakpointService } from '@shared/services/breakpoint.service';

import { DialogService } from '@shared/components/dialog/dialog.service';
import { LogoutConfirmationDialogComponent } from '../logout-confirmation-dialog/logout-confirmation-dialog.component';
import { MainNavService } from '../main-nav/main-nav.service';
import { animateText } from '../main-nav/main-nav-animations';
import { MainNavLinkCollection } from '../main-nav/main-nav-links';
import { MainNavComponent } from '../main-nav/main-nav.component';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-main-sidenav',
  templateUrl: './main-sidenav.component.html',
  styleUrl: './main-sidenav.component.scss',
  animations: [animateText],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MainNavComponent, MatIconButton, MatIcon, MatButton],
})
export class MainSideNavComponent {
  private dialogService = inject(DialogService);
  readonly breakpointService = inject(BreakpointService);
  readonly isNotExtraSmall = this.breakpointService.matches('gt-xs');
  mainNavService = inject(MainNavService);

  readonly closeDrawer = output();

  public linkCollections: MainNavLinkCollection[] = [];

  public fixSideNavOpen(): void {
    this.mainNavService.mainNavFixedOpen$.next(!this.mainNavService.mainNavFixedOpen$.value);
    localStorage.setItem('menu_open', `${!this.mainNavService.mainNavOpen$.value}`);
    this.mainNavService.mainNavOpen$.next(!this.mainNavService.mainNavOpen$.value);
  }

  public signOutButtonClicked(): void {
    this.dialogService.openDialog(LogoutConfirmationDialogComponent);
  }
}
